// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.innerContainer {
  padding: 40px;
}

.orderRow {
  font-size: 14px;
}

.timelineList {
  margin: 0px;
}

.timelinestatus {
  font-size: 16px;
}

.timeline {
  margin: auto;
  padding-top: 20px;
}

.orderHeaderParent {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  /* gap: 5px; */
  margin-bottom: 10px;
}


.cancelBtn {
  background-color: rgb(54, 54, 54) !important;
  color: white;
  padding: 10px 40px;
  font-size: 13p;
}

.cancelBtn:disabled {
  color: gray !important;
}

.orderHeaderContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.btnContainer {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.requestHeaderContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
}

.paid {
  color: green;
  font-weight: bold;
}

.unpaid {
  color: rgb(198, 198, 8);
  font-weight: bold;
}

.detailCard {
  width: 100%;
}

.cartImageParent {
  /* background-color: aqua; */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.berthCartImage {
  width: 350px;
  height: 200px;
  object-fit: cover;
}

.dateRangeContainer {
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}

.orderItems {
  font-size: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  /* gap: 60px; */
}

.borderTop {
  width: 100%;
  height: 2px;
  border-top: 2px dotted #ccc !important;
}

.firstCartItemContainer {
  width: 300px;
}

.orderButton {
  margin-top: 20px !important;
  width: 200px !important;
}

.CartItemContainer {
  width: 380px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 10px;
}

.note {
  margin: 20px 0px;
}`, "",{"version":3,"sources":["webpack://./src/pages/yacht/home/nested/cart/Cart.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;EACd,mBAAmB;AACrB;;;AAGA;EACE,4CAA4C;EAC5C,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".innerContainer {\n  padding: 40px;\n}\n\n.orderRow {\n  font-size: 14px;\n}\n\n.timelineList {\n  margin: 0px;\n}\n\n.timelinestatus {\n  font-size: 16px;\n}\n\n.timeline {\n  margin: auto;\n  padding-top: 20px;\n}\n\n.orderHeaderParent {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  /* gap: 5px; */\n  margin-bottom: 10px;\n}\n\n\n.cancelBtn {\n  background-color: rgb(54, 54, 54) !important;\n  color: white;\n  padding: 10px 40px;\n  font-size: 13p;\n}\n\n.cancelBtn:disabled {\n  color: gray !important;\n}\n\n.orderHeaderContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.btnContainer {\n  margin-top: 20px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.requestHeaderContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 15px;\n}\n\n.paid {\n  color: green;\n  font-weight: bold;\n}\n\n.unpaid {\n  color: rgb(198, 198, 8);\n  font-weight: bold;\n}\n\n.detailCard {\n  width: 100%;\n}\n\n.cartImageParent {\n  /* background-color: aqua; */\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 20px;\n}\n\n.berthCartImage {\n  width: 350px;\n  height: 200px;\n  object-fit: cover;\n}\n\n.dateRangeContainer {\n  margin-top: 16px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 10px;\n}\n\n.orderItems {\n  font-size: 16px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  /* gap: 60px; */\n}\n\n.borderTop {\n  width: 100%;\n  height: 2px;\n  border-top: 2px dotted #ccc !important;\n}\n\n.firstCartItemContainer {\n  width: 300px;\n}\n\n.orderButton {\n  margin-top: 20px !important;\n  width: 200px !important;\n}\n\n.CartItemContainer {\n  width: 380px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 10px;\n}\n\n.note {\n  margin: 20px 0px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
